import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Calendar, Clock } from "lucide-react";
import { USAGE_VIEW_TYPES } from "@/constants/usage";
export const ViewTypeToggle = ({ viewType, onChange })=>{
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("label", {
                className: "block text-sm font-medium text-gray-700 mb-2",
                children: "View Type"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex rounded-md shadow-sm",
                children: [
                    /*#__PURE__*/ _jsxs("button", {
                        onClick: ()=>onChange(USAGE_VIEW_TYPES.HOURLY),
                        className: `px-4 py-2 text-sm font-medium rounded-l-md border ${viewType === USAGE_VIEW_TYPES.HOURLY ? "bg-navy-70 text-white border-navy-70" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`,
                        children: [
                            /*#__PURE__*/ _jsx(Clock, {
                                className: "w-4 h-4 inline mr-1"
                            }),
                            "Hourly"
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("button", {
                        onClick: ()=>onChange(USAGE_VIEW_TYPES.DAILY),
                        className: `px-4 py-2 text-sm font-medium rounded-r-md border-t border-r border-b ${viewType === USAGE_VIEW_TYPES.DAILY ? "bg-navy-70 text-white border-navy-70" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`,
                        children: [
                            /*#__PURE__*/ _jsx(Calendar, {
                                className: "w-4 h-4 inline mr-1"
                            }),
                            "Daily"
                        ]
                    })
                ]
            })
        ]
    });
};
